<template>
  <v-container
    class="fill-height d-flex flex-row justify-center align-end my-0 py-0"
  >
    <v-img
      v-if="$root.isDesktop"
      class="image1-position"
      max-width="130px"
      :src="image1"
    ></v-img>
    <v-img
      v-if="$root.isDesktop"
      class="image2-position"
      max-width="130px"
      :src="image1"
    ></v-img>
    <v-img
      v-if="$root.isDesktop"
      class="circle1-position"
      max-width="190px"
      :src="image2"
    ></v-img>
    <v-img
      v-if="$root.isDesktop"
      class="circle2-position"
      max-width="140px"
      :src="image3"
    ></v-img>
    <span class="title-font-secondary text-center" v-html="t('title')"></span>
    <v-row class="dense d-flex justify-center">
      <v-col cols="12" md="4">
        <sc-btn block outlined @click="openAdmin">{{ t("btnOperation") }}</sc-btn>
      </v-col>
      <v-col cols="12" md="4">
        <sc-btn block @click="openPointSale">{{ t("btnPointofSale") }}</sc-btn>
      </v-col>
    </v-row>
    <v-img
      class="ma-0 pa-0"
      max-width="70%"
      height="auto"
      :src="image4"
    ></v-img>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    image1: require("@/assets/images/image-1.png"),
    image2: require("@/assets/images/large-circle.png"),
    image3: require("@/assets/images/small-circle.png"),
    image4: require("@/assets/images/finished.png"),
  }),
  methods: {
    t(key, options = {}) {
      return this.$t(`designer.finished.${key}`, options);
    },
    openAdmin(){
      window.open(process.env.VUE_APP_BEADMIN, '_blank').focus();
    },
    openPointSale(){
      const url = `https://${this.$store.state.designer.model.domain}`
      window.open(url, '_blank').focus();
    }
  },
};
</script>

<style lang="scss" scoped>
.image1-position {
  position: absolute;
  top: 10%;
  left: 96%;
  z-index: 0;
}
.image2-position {
  position: absolute;
  top: 80%;
  right: 96%;
  z-index: 0;
}
.circle1-position {
  position: absolute;
  right: 0%;
  top: 10%;
  z-index: 0;
}
.circle2-position {
  position: absolute;
  left: 0%;
  top: 20%;
  z-index: 0;
}
</style>
